import {Injectable} from '@angular/core';
import {Melody} from "../model/melody";
import {encryptNumber} from "../utils/encryption.utils";
import {constants} from "../constants";
import {Metrika} from "ng-yandex-metrika";
import {CookieService} from "ngx-cookie-service";

declare global {
  interface Window {
    ym: any;
    ymCallbacks: Function[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class MetrikaService {
  private _encryptedMsisdn: string;

  constructor(private metrika: Metrika,
              private cookieService: CookieService) {
    this._encryptedMsisdn = this.cookieService.get(constants.encryptedMsisdn);
  }

  encryptMsisdn(msisdn: string) {
    this._encryptedMsisdn = msisdn ? encryptNumber(msisdn) : null;
    this.cookieService.set(constants.encryptedMsisdn, this._encryptedMsisdn, undefined, '/');
  }

  get encryptedMsisdn() {
    return this.cookieService.get(constants.encryptedMsisdn)
  }

  addEvent(event: string, msisdn: string, actionState: string, melody?: Melody, recipient?: string, ugcName?: string) {
    const eventDataYandex = {
      ...(recipient && { recipient: encryptNumber(recipient)}),
      melody_id: melody?.rbtCode,
      melody_name: melody?.title,
      melody_author: melody?.artistTitle,
      actionState: actionState,
      ...(this.encryptedMsisdn !== null && { ctn: this.encryptedMsisdn }),
      ugc_name: ugcName,
    };

    this.metrika.reachGoal(event, {...eventDataYandex, params: eventDataYandex})
  }
}
